import { CarryOutOutlined, PieChartOutlined } from "@ant-design/icons"
import { Space, Tag, Tooltip, Typography } from "antd"
import Title from "antd/lib/typography/Title"
import moment from "moment"
import { EventStatusTag, eventTagStyle, getEventListStatus } from "./EventStatusTag"
import { formatDateString } from "../../Helpers/DateHelpers"
import { TextService } from "../../Services/TextService"
import { EventType } from "../../Types/EventType"

const { Text } = Typography;

/**
 * The top of every page of an event: the name with its type and status and when it is. The link and the button that
 * closes or opens the event are on Status & Svar.
 */
export const EventHeader = (props: { event: any }) => {
    const GetText = TextService.GetText;
    const event = props.event;
    const status = getEventListStatus({ state: event.eventState, deadline: event.eventDeadline, times: event.times });
    const isPoll = event.eventType === EventType.Poll;
    const times: any[] = [...(event.times ?? [])].sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf());

    // One time is shown in full, several as how many and from when.
    const when = times.length === 1 ?
        moment(times[0].start).format("ddd D MMM HH:mm") + (times[0].end ? "–" + moment(times[0].end).format("HH:mm") : "") :
        times.length > 1 ? times.length + " " + GetText("EventHeader_Times") + " · " + moment(times[0].start).format("ddd D MMM") + " – " + moment(times[times.length - 1].start).format("ddd D MMM") : "";

    if (!event.eventId) {
        return <Title>&nbsp;</Title>;
    }

    return <div style={{ marginBottom: 16 }}>
        <div style={{ textAlign: "left" }}>
            <Space wrap align="center">
                <Title style={{ margin: 0 }}>{event.eventName}</Title>
                {/* The event type, with the same icons as when the event is created. */}
                <Tooltip title={GetText(isPoll ? "EventType_PollDescription" : "EventType_SignUpDescription")}>
                    <Tag icon={isPoll ? <PieChartOutlined /> : <CarryOutOutlined />} color={isPoll ? "purple" : "blue"} style={{ ...eventTagStyle, cursor: "help" }}>
                        {GetText(isPoll ? "EventType_Poll" : "EventType_SignUp")}
                    </Tag>
                </Tooltip>
                {/* The same status as on /myevents. */}
                <EventStatusTag status={status} />
            </Space>
            {when || event.eventDeadline ?
                <div style={{ marginTop: 4 }}>
                    <Text type="secondary">
                        {when}
                        {when && event.eventDeadline ? " · " : ""}
                        {event.eventDeadline ? GetText("EventDetails_EventDeadline") + " " + formatDateString(event.eventDeadline) : ""}
                    </Text>
                </div> : null}
        </div>
    </div>
}
